const DAY = /\b(lunes|martes|mi[eé]rcoles|jueves|viernes|s[aá]bados?|domingos?|lun|mi[eé]|jue|vie|s[aá]b|dom|monday|tuesday|wednesday|thursday|friday|saturdays?|sundays?|mon|tue|tues|wed|thu|thur|fri|sat|sun|weekdays|weekends?|fines de semana|entre semana|diario|daily|everyday)\b/i;
const TIME = /(?<![\d(])\d{1,2}(?::\d{2}|\s*(?:a\.?\s?m\.?|p\.?\s?m\.?|h\b|hrs))\s*(?:[–—-]|to|a)\s*\d{1,2}(?::\d{2})?\s*(?:a\.?\s?m\.?|p\.?\s?m\.?|h\b|hrs)?(?!\d)/i;
const CLOSED = /^\s*(cerrado|closed)\s*$/i;
const TEXT_TYPES = new Set(['text', 'heading', 'paragraph']);
function kindOf(node) {
    if (!TEXT_TYPES.has(node.type) || typeof node.content !== 'string')
        return null;
    /* Los datos de contacto se rellenan aparte (`contactCards.ts`). */
    if (typeof node.contactSlot === 'string')
        return null;
    const text = node.content.replace(/<[^>]*>/g, '').trim();
    if (!text || text.length > 60)
        return null;
    const day = DAY.test(text);
    const time = TIME.test(text) || CLOSED.test(text);
    if (day && time)
        return 'both';
    if (day)
        return 'day';
    if (time)
        return 'time';
    return null;
}
/** Las filas de horario limpias: cada una con días y horas, como mucho siete. */
export function normalizeBusinessHours(raw) {
    if (!Array.isArray(raw))
        return [];
    return raw.flatMap((entry) => {
        const item = (entry && typeof entry === 'object' ? entry : {});
        const days = typeof item.days === 'string' ? item.days.trim().slice(0, 40) : '';
        const time = typeof item.time === 'string' ? item.time.trim().slice(0, 40) : '';
        return days && time ? [{ days, time }] : [];
    }).slice(0, 7);
}
/** El horario en una línea, para el pie: «Lunes a viernes · 8:00 – 18:00». */
export function businessHoursLines(rows) {
    return rows.map((row) => `${row.days} · ${row.time}`);
}
/** Si estos nodos traen un horario (de muestra o no). */
export function showsBusinessHours(nodes) {
    let days = 0;
    let times = 0;
    const visit = (node) => {
        const kind = kindOf(node);
        if (kind === 'both') {
            days += 1;
            times += 1;
        }
        if (kind === 'day')
            days += 1;
        if (kind === 'time')
            times += 1;
        node.children.forEach(visit);
    };
    nodes.forEach(visit);
    return days > 0 && times > 0;
}
/**
 * Cambia el horario de muestra de cada sección por `rows`. Por sección (cada
 * nodo raíz por separado): sólo donde hay a la vez días y horas, para no tocar
 * un «Abrimos los lunes» suelto de un texto.
 */
export function fillBusinessHours(roots, rows) {
    if (!rows.length)
        return roots;
    for (const root of roots) {
        if (!showsBusinessHours([root]))
            continue;
        let both = 0;
        let day = 0;
        let time = 0;
        const drop = new Set();
        const visit = (node) => {
            const kind = kindOf(node);
            if (kind === 'both') {
                const row = rows[both++];
                if (row)
                    node.content = `${row.days} · ${row.time}`;
                else
                    drop.add(node);
            }
            else if (kind === 'day') {
                const row = rows[day++];
                if (row)
                    node.content = row.days;
                else
                    drop.add(node);
            }
            else if (kind === 'time') {
                const row = rows[time++];
                if (row)
                    node.content = row.time;
                else
                    drop.add(node);
            }
            node.children.forEach(visit);
        };
        visit(root);
        if (!drop.size)
            continue;
        /* Lo que sobra fuera; y un contenedor que se queda vacío por eso, también. */
        const prune = (node) => {
            const before = node.children.length;
            node.children = node.children.filter((child) => !drop.has(child) && !prune(child));
            return before > 0 && node.children.length === 0 && node.type !== 'section' && typeof node.content !== 'string';
        };
        prune(root);
    }
    return roots;
}
//# sourceMappingURL=businessHours.js.map